import React from "react"
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faArrowAltCircleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./css/Footer.css"
import {Link} from 'react-scroll'

library.add(fab);

export default function Footer(){

    return(
        <footer id="footer" className="footer text-center pb-0">
            <div className="container">
                <div className="row pb-3">
                    <div className="col-12 col-md-4 pb-5 text-center">
                        <p>Created By
                            <br/>
                            <a href="https://www.linkedin.com/in/rijalpermana">Rijal<br className="d-none d-lg-block col-md-12"/>&nbsp;Permana</a>.
                        </p>
                        <div className="col-12 social-links text-center">
                            <a target="_blank" rel="noreferrer" href="https://www.twitter.com/rijalpermana" className="twitter">
                                <FontAwesomeIcon icon={['fab','twitter']}></FontAwesomeIcon>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/rijalpermana00" className="facebook">
                                <FontAwesomeIcon icon={['fab','facebook']}></FontAwesomeIcon>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/rijalpermanaa" className="instagram">
                                <FontAwesomeIcon icon={['fab','instagram']}></FontAwesomeIcon>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/rijalpermana" className="linkedin">
                                <FontAwesomeIcon icon={['fab','linkedin']}></FontAwesomeIcon>
                            </a>
                        </div>
                    </div>
                    <div className="col-md-4 pb-5">
                        <p>
                            Powered By 
                            <br/>
                            <a href="https://reactjs.org/"><FontAwesomeIcon className="spin-dat" icon={['fab','react']}/> React Js</a>
                            <br/>
                            <a href="https://nodejs.org/"><FontAwesomeIcon className="spin-dat" icon={['fab','node']}/> Node Js</a>
                        </p>
                    </div>
                    <div className="col-12 col-md-4 pb-5 text-center">
                        <p>Designed By
                            <br/>
                            <a href="https://www.linkedin.com/in/rizkyanandra">Rizky<br className="d-none d-lg-block col-md-12"/>&nbsp;Anandra</a>.
                        </p>
                        <div className="col-12 social-links text-center">
                            <a target="_blank" rel="noreferrer" href="https://www.twitter.com/RZK_Anandra" className="twitter">
                                <FontAwesomeIcon icon={['fab','twitter']}></FontAwesomeIcon>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/rizky.anandra" className="facebook">
                                <FontAwesomeIcon icon={['fab','facebook']}></FontAwesomeIcon>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/carizky13" className="instagram">
                                <FontAwesomeIcon icon={['fab','instagram']}></FontAwesomeIcon>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/rizkyanandra" className="linkedin">
                                <FontAwesomeIcon icon={['fab','linkedin']}></FontAwesomeIcon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}